import React from 'react'
import { Box, SimpleGrid } from '@chakra-ui/react'
// import MyWorks from '../works/components/MyWorks'
// import ProjectOverview from '../works/components/ProjectOverview'
// import QuickActions from '../works/components/QuickActions'

const WorkSection = ({ data, loading }) => {
  return (
    <Box>
      <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={4} mb={6}>
        {/* My Works - Takes full width on mobile, 1 column on large screens */}


        {/* Project Overview - Takes full width on mobile, 1 column on large screens */}


        {/* Quick Actions - Takes full width on mobile, 1 column on large screens */}
        {/* <Box gridColumn={{ base: '1', lg: 'span 1' }}>
          <QuickActions/>
        </Box> */}
      </SimpleGrid>
    </Box>
  )
}

export default WorkSection